import { ADD_DESIGNATION, ADD_DESIGNATION_FAILED, ADD_DESIGNATION_SUCCESS, DESIGNATION, DESIGNATION_FAILED, DESIGNATION_SUCCESS, UPDATE_DESIGNATION, UPDATE_DESIGNATION_FAILED, UPDATE_DESIGNATION_SUCCESS } from "./actionTypes"

let initialState = {
    designation: [],
    addDesignation: "",
    updateDesignation: "",
    loading: false,
    success: false,
    error: ''
}

export const designationReducer = (state = initialState, action) => {
    switch (action.type) {

        case DESIGNATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case DESIGNATION_SUCCESS: return {
            ...state,
            designation: action.payload,
            loading: false,
            success: true
        }
        case DESIGNATION_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_DESIGNATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_DESIGNATION_SUCCESS: return {
            ...state,
            addDesignation: action.payload,
            designation: [...state.designation, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_DESIGNATION_FAILED: return {
            ...state,
            addDesignation: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_DESIGNATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_DESIGNATION_SUCCESS: return {
            ...state,
            updateDesignation: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_DESIGNATION_FAILED: return {
            ...state,
            updateDesignation: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}